module.exports = __webpack_public_path__ + "img/20191203170038361.2cb782e9.jpg";